import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import type FileModel from 'modules/bookkeepers/store/models/File'

interface Props {
  file?: FileModel
  downloadUrl?: string
  filename?: string | null | undefined
}

const FileCard = ({ file, downloadUrl, filename }: Props) => {
  const isBookkeeperView = useBookkeeperView()

  return (
    <a
      href={file ? file.downloadUrl(isBookkeeperView) : downloadUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Box
        borderRadius={{
          all: 'abs008',
        }}
        border={{
          all: {
            color: 'grey400',
            width: 's1',
            style: 'solid',
          },
        }}
        paddingX="s16"
        paddingY="s12"
        flexDirection="row"
        alignItems="center"
        gap="s8"
      >
        <Box flexNoShrink>
          <Icon.Medium icon="file" />
        </Box>
        <Box flexGrow overflowX="hidden">
          <Text.Normal ellipsis weight="medium" size="300" color="grey800">
            {file ? file.attributes.filename : filename}
          </Text.Normal>
        </Box>
        <Box flexNoShrink>
          <Icon.Medium icon="download" />
        </Box>
      </Box>
    </a>
  )
}

export default FileCard
